module.exports = __webpack_public_path__ + "static/media/open_chat.1dc52c60.svg";